<!--选择职能层级-->
<template>
  <div>
    <el-tag style="margin: 10px;" v-for="tag in selectedOrg" @close="removeSelectedOrg(tag)" :key="tag.organizeId" closable>{{tag.organizeName}}</el-tag>
    <el-tree style="margin-top: 30px;" :data="data" :props="defaultProps">
      <span class="slot-t-node" slot-scope="{ node, data }">
        <span>{{ node.label }}</span>
        <el-popover placement="right" v-model="data.hidden" trigger="click">
          <div>
            <i class="i_close iconfont iconclose_light" @click="close_sub_org(data)"></i>
            <el-tree class="sub_tree" :data="data.childOrganizes" @check-change="checkChange" :props="defaultProps">
              <span class="slot-t-node" slot-scope="{ node, data }">
                <!-- 带操作权限 -->
                <!-- <el-checkbox :disabled="data.permissFlag===0" v-on:change="r =>checkChange(r,node,data)" style="margin-right: 5px;" v-model="data.hidden" /> -->
                <!-- 带操作权限 -->
                <!-- 不带操作权限 -->
                <el-checkbox v-on:change="r =>checkChange(r,node,data)" style="margin-right: 5px;" v-model="data.hidden" />
                <!-- 不带操作权限 -->
                <span>{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
          <span class="show-hidden" slot="reference" v-on:click.stop="printData(data)">
            <span class="child-lenght">[ {{data.childOrganizes.length}} ]</span>
            <i class="iconfont iconright" :class="data.hidden?'iconleft':'iconright'"></i>
          </span>
        </el-popover>
      </span>
    </el-tree>
  </div>
</template>

<script>
import { moveOrganizeInfosOfUser, batchMovePersonnel } from "@/api/api.js";

export default {
  name: "choice-org",
  props: {
    isShowMoveUserOrgDialog: {
      type: Boolean
    },
    userId: {
      type: Number
    }
  },
  data() {
    return {
      data: [],
      defaultProps: {
        children: "subOrganizes",
        label: "organizeName"
      },
      selectedOrg: []
    };
  },
  methods: {
    checkChange(r, node, data) {
      if (r) {
        //添加
        this.selectedOrg.push({
          organizeId: data.organizeId,
          organizeName: data.organizeName
        });
      } else {
        //删除
        for (let i in this.selectedOrg) {
          let item = this.selectedOrg[i];
          if (item.organizeId === data.organizeId) {
            this.selectedOrg.splice(i, 1);
            break;
          }
        }
      }
    },
    printData(data) {
      // console.log(data);
    },
    removeSelectedOrg(tag) {
      //移除已选的部门
      for (let i in this.selectedOrg) {
        let item = this.selectedOrg[i];
        if (item.organizeId === tag.organizeId) {
          this.selectedOrg.splice(i, 1);
          break;
        }
      }
    },
    close_sub_org(node) {
      //关闭
      node.hidden = false;
      this.changeGlobleState(this.data[0], node, node.organizeId);
    },
    //根据id值改变该id对应的所有数据
    changeGlobleState(globalData, subData, id) {
      if (globalData.organizeId === id) {
        globalData = subData;
      } else if (globalData.subOrganizes !== null && globalData.subOrganizes.length > 0) {
        for (var i = 0; i < globalData.subOrganizes.length; i++) {
          var item = globalData.subOrganizes[i];
          if (item.organizeId === id) {
            item = subData;
            return; //找到了就结束递归
          }
          if (item.subOrganizes != null && item.subOrganizes.length > 0) {
            this.changeGlobleState(item, subData, id);
          }
        }
      }
    },
    changeState(data, id, state) {
      for (let i in data) {
        let nodes = data[i];
        for (let j in nodes.childOrganizes) {
          let child = nodes.childOrganizes[j];
          if (child.organizeId === id || id === -1) {
            // child.checkItem = state;
            //要用此方法布局才会重新渲染
            this.$set(data[i].childOrganizes[j], "hidden", state);
          }
        }
        this.changeState(nodes.subOrganizes, id, state);
      }
    },
    async getSelectedUserInfo() {
      //清空数据
      const info = await moveOrganizeInfosOfUser({ userId: this.userId });
      this.data = Array.of(info.data.organizeTreeDto);
      this.selectedOrg = info.data.organizeList;
      for (let i in this.selectedOrg) {
        let tag = this.selectedOrg[i];
        this.changeState(this.data, tag.organizeId, true);
      }
    },
    async moveUser() {
      let oids = [];
      for (let i = 0; i < this.selectedOrg.length; i++) {
        oids.push(this.selectedOrg[i].organizeId);
      }
      let result = await batchMovePersonnel({ organizeIds: oids, userIds: [this.userId] });
      this.$message({
        message: "调动成功",
        type: "success"
      });
      this.$emit("update:isShowMoveUserOrgDialog", false);
    },
    cmdMoveUser() {
      this.moveUser();
    }
  },
  mounted() {
    //始终使用最新数据，最好不要用传入数据
    this.getSelectedUserInfo();
  },
  updated() {},
  destroyed() {},
  created() {},
  watch: {
    userId: function() {
      this.getSelectedUserInfo();
    },
    selectedOrg: function(n) {
      //先复位所有数据，-1表示所有id
      this.changeState(this.data, -1, false);
      for (let i in this.selectedOrg) {
        let tag = this.selectedOrg[i];
        this.changeState(this.data, tag.organizeId, true);
      }
    }
  }
};
</script>

<style scoped>
.show-hidden {
  color: royalblue;
  margin-left: 10px;
  /*静止选择*/
  -webkit-touch-callout: none;
  /* iOS Safari */

  -webkit-user-select: none;
  /* Chrome/Safari/Opera */

  -khtml-user-select: none;
  /* Konqueror */

  -moz-user-select: none;
  /* Firefox */

  -ms-user-select: none;
  /* Internet Explorer/Edge */

  user-select: none;
  /* Non-prefixed version, currently
not supported by any browser */
}

.child-lenght {
  color: #f9887a;
  margin-left: 10px;
}

.i_close {
  color: dimgrey;
  position: relative;
  left: 90%;
  cursor: pointer;
  font-size: 12px;
}

.iconright {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/organize/choice-org.vue